export interface PropertyItem {
  id: string;
  title: string;
  location: string;
  city: "Mumbai" | "Bangalore" | "Dubai" | "London" | "Goa" | "Chennai";
  type: "Penthouse" | "Villa" | "Commercial" | "Apartment";
  priceINR: string;
  priceUSD: string;
  numericINR: number;
  numericUSD: number;
  beds: number | string;
  baths: number;
  areaSqFt: number;
  highlight: string;
  badge?: string;
  image: string;
  features: string[];
}

export const FEATURED_PROPERTIES: PropertyItem[] = [
  {
    id: "prop-1",
    title: "The Grand Bel-Air Penthouse",
    location: "Worli Sea Face, Mumbai",
    city: "Mumbai",
    type: "Penthouse",
    priceINR: "₹14.50 Cr",
    priceUSD: "$1.75M",
    numericINR: 145000000,
    numericUSD: 1750000,
    beds: 4,
    baths: 5,
    areaSqFt: 5400,
    highlight: "Panoramic Arabian Sea Horizon & 1,200 sq.ft Private Deck",
    badge: "Signature Collection",
    image: "https://images.unsplash.com/photo-1600596542815-ffad4c1539a9?auto=format&fit=crop&w=1200&q=80",
    features: ["Private Infinity Sky Pool", "Private Elevator Access", "3 Covered EV Valet Slots", "Automated Crestron Lighting"]
  },
  {
    id: "prop-2",
    title: "Emerald Sanctuary Private Estate",
    location: "Palm Grove Valley, North Goa",
    city: "Goa",
    type: "Villa",
    priceINR: "₹8.20 Cr",
    priceUSD: "$980K",
    numericINR: 82000000,
    numericUSD: 980000,
    beds: 5,
    baths: 6,
    areaSqFt: 7200,
    highlight: "Portuguese Heritage Architecture with Bali-Style Gazebos",
    badge: "Ultra Luxury Estate",
    image: "https://images.unsplash.com/photo-1613977257363-707ba9348227?auto=format&fit=crop&w=1200&q=80",
    features: ["Private Heated Lap Pool", "Tropical Landscaped Lawn", "Staff Quarters On-Premises", "Gated 24/7 Armed Security"]
  },
  {
    id: "prop-3",
    title: "Skyline One Financial Tower",
    location: "DIFC Financial District, Dubai",
    city: "Dubai",
    type: "Commercial",
    priceINR: "₹19.50 Cr",
    priceUSD: "$2.35M",
    numericINR: 195000000,
    numericUSD: 2350000,
    beds: "Full Floor",
    baths: 8,
    areaSqFt: 8900,
    highlight: "Grade-A LEED Platinum Asset with 9.2% Net ROI Lease Guarantee",
    badge: "Institutional Grade",
    image: "https://images.unsplash.com/photo-1545324418-cc1a3fa10c00?auto=format&fit=crop&w=1200&q=80",
    features: ["Pre-Leased to Tech MNC", "Zero Personal Tax Haven", "Dedicated Boardrooms & Terraces", "Direct Metro Concourse Link"]
  },
  {
    id: "prop-4",
    title: "The Kensington Mews Duplex",
    location: "Kensington High Street, London W8",
    city: "London",
    type: "Penthouse",
    priceINR: "₹16.80 Cr",
    priceUSD: "$2.05M",
    numericINR: 168000000,
    numericUSD: 2050000,
    beds: 3,
    baths: 4,
    areaSqFt: 2850,
    highlight: "Victorian Facade with Ultra-Modern Minimalist Glass Atrium",
    badge: "Prime International",
    image: "https://images.unsplash.com/photo-1600607687939-ce8a6c25118c?auto=format&fit=crop&w=1200&q=80",
    features: ["Private Mews Courtyard", "Sub-Zero Chef Kitchen", "24h Uniformed Concierge", "Freehold Ownership Title"]
  },
  {
    id: "prop-5",
    title: "Serene Pavilions Club Residences",
    location: "Whitefield Corridor, Bangalore",
    city: "Bangalore",
    type: "Villa",
    priceINR: "₹4.75 Cr",
    priceUSD: "$570K",
    numericINR: 47500000,
    numericUSD: 570000,
    beds: 4,
    baths: 4,
    areaSqFt: 4600,
    highlight: "Adjacent to 40-Acre Eco Lake with Private Tennis Club",
    badge: "Family Signature",
    image: "https://images.unsplash.com/photo-1600585154340-be6161a56a0c?auto=format&fit=crop&w=1200&q=80",
    features: ["Private Home Cinema Room", "Double-Height Glass Foyer", "Solar Net-Metering Equipped", "Minutes from Outer Ring Road"]
  },
  {
    id: "prop-6",
    title: "The Azure Oceanfront Suite",
    location: "ECR Seaside Corridor, Chennai",
    city: "Chennai",
    type: "Apartment",
    priceINR: "₹3.90 Cr",
    priceUSD: "$470K",
    numericINR: 39000000,
    numericUSD: 470000,
    beds: 3,
    baths: 3,
    areaSqFt: 3200,
    highlight: "Direct Unobstructed Bay of Bengal Waves & Sunset Deck",
    badge: "Coastal Living",
    image: "https://images.unsplash.com/photo-1512917774080-9991f1c4c750?auto=format&fit=crop&w=1200&q=80",
    features: ["Private Boardwalk to Beach", "Wrap-Around Sea Balcony", "Smart Keyless Lock System", "Rooftop Hydrotherapy Spa"]
  }
];
